var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"root room-unlocked-chat-message",class:{ own: _vm.isOwn }},[_c('div',{staticClass:"message-container",domProps:{"innerHTML":_vm._s(_vm.message.body)}})])}
var staticRenderFns = []

export { render, staticRenderFns }